import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Ticket, TicketFarben } from '../../../../../projects/kiene-core/src/lib/classes/ticket';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { TicketsystemService } from '../../../../../projects/kiene-core/src/lib/services/ticketsystem/ticketsystem.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import {
    DateTableColumn,
    KieneBooleanTableColumn,
    StatusTableColumn,
    TableColumn,
} from '../../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../../components/kiene-table/table-option';
import { PrioritaetenDialogComponent } from '../../prioritaeten-dialog/prioritaeten-dialog.component';
import { Subscription } from 'rxjs';
import {
    FilterItem,
    FilterItemType,
} from '../../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';

@Component({
    selector: 'kiene-ticket-uebersicht-offene',
    templateUrl: './ticket-uebersicht-offene.component.html',
    styleUrls: ['./ticket-uebersicht-offene.component.scss'],
})
export class TicketUebersichtOffeneComponent implements OnInit, OnDestroy {
    openTableDescriptor = new TableDescriptor();
    isAdmin = false;
    isPhitoAdmin = false;
    neuesTicketErstelltSub: Subscription;

    constructor(
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly dialog: MatDialog,
        private readonly router: Router,
        private readonly api: KieneBackendApiService,
        private readonly tableService: KieneTableService,
        private readonly localStorageService: LocalStorageService,
        private readonly messageService: MessageService,
        private readonly ticketsystemService: TicketsystemService,
    ) {}

    ngOnInit(): void {
        this.isAdmin = this.localStorageService.currentUserIsAdmin();
        this.isPhitoAdmin = this.localStorageService.isCurrentUserPhitoUser();
        this.initOpenTable();

        this.neuesTicketErstelltSub = this.ticketsystemService.watchNeuesTicketErstellt().subscribe({
            next: () => {
                this.tableService.reload('TicketUebersichtOffeneComponent');
            },
        });
    }

    ngOnDestroy(): void {
        this.neuesTicketErstelltSub?.unsubscribe();
    }

    initOpenTable() {
        this.openTableDescriptor.headline = 'Offene Tickets';
        this.openTableDescriptor.alternativeApiUrl = this.apiBaseUrl + 'ticket/read_offen.php';

        this.openTableDescriptor.initialSortColumn = 'prioritaet';
        this.openTableDescriptor.initialSortDirection = 'desc';
        this.openTableDescriptor.nameOfIdField = 'ticket_id';
        this.openTableDescriptor.uniqueIdentifier = 'TicketsOffen';
        this.openTableDescriptor.defaultPageSize = 20;
        this.openTableDescriptor.showDetailsVoid = this.gotoDetails.bind(this);
        this.openTableDescriptor.addVoid = this.add.bind(this);
        this.openTableDescriptor.sendCurrentClient = true;
        this.openTableDescriptor.createAllowed = true;
        this.openTableDescriptor.standardCreate = false;

        this.openTableDescriptor.permissionView = 10031;
        this.openTableDescriptor.permissionCreate = 10032;

        this.openTableDescriptor.columns = this.getOpenColumns();
        this.openTableDescriptor.options = this.getOpenOptions();
        if (this.localStorageService.isCurrentUserPhitoUser()) {
            this.openTableDescriptor.addToolbarButton(
                new ToolbarButton(this.syncPhito.bind(this), 'update', 10031, 'Synchronisieren'),
            );
        }

        this.openTableDescriptor.filterItems.push(
            new FilterItem('Neu', 224, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.openTableDescriptor.filterItems.push(
            new FilterItem('Freigegeben', 225, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.openTableDescriptor.filterItems.push(
            new FilterItem('In Bearbeitung', 227, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.openTableDescriptor.filterItems.push(
            new FilterItem('Fertig', 228, FilterItemType.CHECKBOX, 'status_id', true),
        );
    }

    getOpenColumns() {
        const columns = [];
        columns.push(new TableColumn('ticket_id', 'ID', 'number', true));
        if (this.localStorageService.currentUserIsAdmin()) {
            columns.push(new TableColumn('typ', 'Support-Typ', 'string', true));
        }

        const valueColorMap = new Map<number, string>();
        valueColorMap.set(230, TicketFarben.getColor(230));
        valueColorMap.set(229, TicketFarben.getColor(229));
        valueColorMap.set(228, TicketFarben.getColor(228));
        valueColorMap.set(227, TicketFarben.getColor(227));
        valueColorMap.set(226, TicketFarben.getColor(226));
        valueColorMap.set(225, TicketFarben.getColor(225));
        valueColorMap.set(224, TicketFarben.getColor(224));

        columns.push(new StatusTableColumn('status', 'Status', valueColorMap));
        if (this.localStorageService.hasPermission(10044)) {
            columns.push(new TableColumn('prioritaet_bez', 'Priorität', 'string', true));
        }
        if (this.localStorageService.isCurrentUserPhitoUser()) {
            columns.push(new KieneBooleanTableColumn('an_phito', 'Phito'));
        }
        columns.push(new TableColumn('titel', 'Titel', 'string', true));
        columns.push(new TableColumn('ersteller', 'Ersteller', 'string', true));
        columns.push(new TableColumn('zugewiesen', 'Zugewiesen'));
        columns.push(new DateTableColumn('letzter_kommentar', 'Letzter Kommentar'));
        columns.push(new DateTableColumn('editiert', 'Editiert'));
        return columns;
    }

    gotoDetails(ticketInput: Ticket) {
        this.router.navigate(['/support', 'tickets', ticketInput.ticket_id]).then();
    }

    add() {
        this.ticketsystemService.openCreateTicketDialog(); // lädt über service neu
    }

    private openPrioritaetenDialog(ticketInput: Ticket): void {
        this.dialog
            .open(PrioritaetenDialogComponent, { data: ticketInput })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result) {
                        this.tableService.reload('Update Ticket');
                    }
                },
            });
    }

    private deleteTicket(ticket: Ticket): void {
        const confirmInput = new ConfirmDialogInput();
        confirmInput.headline = 'Ticket löschen';
        confirmInput.text = 'Soll das Ticket wirklich gelöscht werden?';
        confirmInput.okButton = 'Löschen';
        this.dialog
            .open(ConfirmDialogComponent, { data: confirmInput })
            .afterClosed()
            .subscribe({
                next: (result: ConfirmDialogResult) => {
                    if (result?.ok && result?.confirmed) {
                        this.api.deleteEntity(this.apiBaseUrl + 'ticket/delete.php', ticket).subscribe({
                            next: () => {
                                this.tableService.reload('Delete Ticket');
                                this.messageService.infoMessage('Ticket wurde gelöscht!');
                            },
                            error: err => {
                                this.messageService.errorMessage('Ticket konnte nicht gelöscht werden!', err);
                            },
                        });
                    }
                },
            });
    }

    public sendTicketToPhito(ticketInput: Ticket): any {
        this.api.post(this.apiBaseUrl + 'ticket/an_phito_senden.php', ticketInput).subscribe({
            next: () => {
                this.tableService.reload('Update Ticket');
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Senden an Phito!', error);
            },
        });
    }

    private getOpenOptions(): TableOption[] {
        const options = [];
        options.push(new TableOption(this.gotoDetails.bind(this), 'Details', 'description', 10031));
        options.push(new TableOption(this.openPrioritaetenDialog.bind(this), 'Priorität setzen', 'start', 10045));
        options.push(
            new TableOption(this.deleteTicket.bind(this), 'Löschen', 'delete', 10030, {
                conditions: [new Condition('status_id', Operator.GLEICH, 224)],
            }),
        );
        if (this.localStorageService.isCurrentUserPhitoUser()) {
            options.push(
                new TableOption(this.sendTicketToPhito.bind(this), 'An Phito senden', 'send', 10031, {
                    conditions: [new Condition('phito_hexid', Operator.EXISTIERT_NICHT, null)],
                }),
            );
            options.push(
                new TableOption(this.openTicketInNewTab.bind(this), 'In Phito anzeigen', 'open_in_new', 10031, {
                    conditions: [new Condition('phito_hexid', Operator.EXISTIERT, null)],
                }),
            );
        }

        return options;
    }

    private openTicketInNewTab(ticketInput: Ticket): void {
        window.open('https://intern.phito.de/maintenance/detail/' + ticketInput.phito_hexid, '_blank');
    }

    private syncPhito() {
        this.api.get(this.apiBaseUrl + 'ticket/sync_phito.php').subscribe({
            next: () => {
                this.tableService.reload('Synchronisiere Phito Tickets');
                this.messageService.infoMessage('Phito Tickets wurden synchronisiert!');
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Synchronisieren der Phito Tickets!', err);
            },
        });
    }
}
